import { getDateInFormat } from "@domains/utils/reportDates";
export var internalCommentMapper = function (data) {
    var result = {
        totalCommentsCount: 0,
        internalComments: [],
    };
    if (data && data.data && data.data.length > 0) {
        result.internalComments = data.data.map(function (item) {
            return {
                id: item.id,
                name: item.name,
                commentDate: getDateInFormat(item.commentdate, "DD-MM-YYYY HH:mm"),
                comment: item.comment,
            };
        });
        result.totalCommentsCount = data.totalitems;
    }
    return result;
};
